import { IPublicClientApplication } from '@azure/msal-browser';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { getAwardProgramStatistic, getAwardStatistic, getCountryAwardStatistic } from './index';

export const createAwardStatisticApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getAwardStatistic: (instance: IPublicClientApplication, awardId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getAwardStatistic(fetchContext, awardId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getAwardStatistic', isInFlight);
    },
  ),
  getCountryAwardStatistic: (instance: IPublicClientApplication, programId: number, countryId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getCountryAwardStatistic(fetchContext, programId, countryId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getCountryAwardStatistic', isInFlight);
    },
  ),
  getAwardProgramStatistic: (instance: IPublicClientApplication, programId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getAwardProgramStatistic(fetchContext, programId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getAwardProgramStatistic', isInFlight);
    },
  ),
});
